import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

import { applicationQuery } from '#admin/features/exhibitor/queries.ts'

export const Route = createFileRoute('/_authenticated/exhibition/exhibitors/$applicationId')({
  staticData: { crumb: useApplicationCrumb },
})

/** "Exhibitors / EX-0001". A draft has no reference yet, and the crumb says so. */
function useApplicationCrumb(): string {
  const { applicationId } = Route.useParams()
  const { data } = useQuery(applicationQuery(applicationId))
  if (data === undefined) return 'Application'
  return data.code ?? 'Draft application'
}
